import { createSlice } from '@reduxjs/toolkit';
import { ebookAccessService } from '../../services/ebookAccessService';

const emptyStats = { totalEbooksAccess: 0, totalSpent: 0, ebooks: [] };

const initialState = {
  purchasedEbooks: ebookAccessService.getPurchasedEbooks(),
  stats: ebookAccessService.getAccessStats(),
};

// Mapeia a resposta da API (loja-api) para o shape interno
// já consumido pelo resto da UI (ebookId/titulo/preco/etc).
function apiToLocal(apiPurchases = []) {
  return apiPurchases
    .filter((p) => p.type === 'ebook')
    .map((p) => ({
      ebookId: p.itemId,
      titulo: p.title,
      preco: p.valor,
      purchasedAt: p.paidAt,
      paymentMethod: p.paymentMethod,
      transactionId: p.id,
      expiresAt: null,
    }));
}

function statsFor(purchased) {
  return {
    totalEbooksAccess: purchased.length,
    totalSpent: purchased.reduce((sum, e) => sum + (e.preco || 0), 0),
    ebooks: purchased,
  };
}

const ebookAccessSlice = createSlice({
  name: 'ebookAccess',
  initialState,
  reducers: {
    loadPurchasedEbooks: (state) => {
      state.purchasedEbooks = ebookAccessService.getPurchasedEbooks();
      state.stats = ebookAccessService.getAccessStats();
    },

    grantEbookAccess: (state, action) => {
      const { ebooks, paymentInfo } = action.payload;
      console.log('💾 [ebookAccessSlice] grantEbookAccess chamado:', { ebooks, paymentInfo });
      ebookAccessService.grantAccess(ebooks, paymentInfo);
      state.purchasedEbooks = ebookAccessService.getPurchasedEbooks();
      state.stats = ebookAccessService.getAccessStats();
      console.log('✅ [ebookAccessSlice] Estado atualizado:', state.purchasedEbooks);
    },

    revokeEbookAccess: (state, action) => {
      const { ebookId } = action.payload;
      ebookAccessService.revokeAccess(ebookId);
      state.purchasedEbooks = ebookAccessService.getPurchasedEbooks();
      state.stats = ebookAccessService.getAccessStats();
    },

    clearAllEbookAccess: (state) => {
      ebookAccessService.clearAllAccess();
      state.purchasedEbooks = [];
      state.stats = emptyStats;
    },

    // Mescla compras da API com o localStorage — API é fonte de verdade, mas itens
    // que ainda não foram sincronizados (ex: falha de rede no recordAnonymous) não
    // desaparecem da UI enquanto ainda estão no localStorage.
    setPurchasedFromApi: (state, action) => {
      const fromApi = apiToLocal(action.payload);
      const fromLocal = ebookAccessService.getPurchasedEbooks();
      const apiIds = new Set(fromApi.map((p) => p.ebookId));
      const merged = [
        ...fromApi,
        ...fromLocal.filter((p) => !apiIds.has(p.ebookId)),
      ];
      state.purchasedEbooks = merged;
      state.stats = statsFor(merged);
    },

    // Logout: limpa estado em memória SEM mexer no localStorage legado.
    clearOnLogout: (state) => {
      state.purchasedEbooks = [];
      state.stats = emptyStats;
    },
  },
});

export const {
  loadPurchasedEbooks,
  grantEbookAccess,
  revokeEbookAccess,
  clearAllEbookAccess,
  setPurchasedFromApi,
  clearOnLogout,
} = ebookAccessSlice.actions;

export default ebookAccessSlice.reducer;
